import { render } from "./HeaderProductLenta.vue?vue&type=template&id=5039bee5&scoped=true"
import script from "./HeaderProductLenta.vue?vue&type=script&lang=js"
export * from "./HeaderProductLenta.vue?vue&type=script&lang=js"

import "./HeaderProductLenta.vue?vue&type=style&index=0&id=5039bee5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5039bee5"]])

export default __exports__